//#region Utils

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region Angular Imports

import { StateService, TransitionService, Transition, RejectType } from "@uirouter/angularjs"
import * as angular from 'angular'

//#endregion

//#region DevExtreme Imports

import dxConfig from 'devextreme/core/config'

//#endregion


// TODO: remove Api
import { Api, LocalDictionaryFactory } from './modules/api/api.module'

// TODO: remove Permissions
import { Permissions } from './helpers/permissions'

import { ConfigHelper, EventsNames, CommonHelper, IUserSession, DataProvider, OperatorComponent, LogHelper, TypeHelper, LocalizationHelper } from './helpers'

import { Activity, Enums } from './models/common'
import { OpOperator, OpDataType, OpDistributor, OpFile, OpDataFormatGroupDetails } from './models/core'
import { OpDashboardControl } from './models/custom'
import { OperatorLayoutSetting, ActiveDistributorsInfo, ActiveDistributorInfo } from './models/local'
import { ObjectCustomString } from './models/util'
import { IMRBaseControlDirectiveController } from './modules/common/base'

interface AppRootScope extends ng.IRootScopeService {
    activeDistributorsDefer: ng.IDeferred<any[]>
    dateFormatsDefer: ng.IDeferred<void>
    activeDistributors: ActiveDistributorsInfo
    alarmsCount: number
    alarmTiles: OpDashboardControl[]
    logo: {
        data: number[] | string,
        ext: string
    }
    rtlState: boolean
    hasPermissions(permissions: string[]): boolean
    i18n: any
}

interface AppScope extends ng.IScope {
    APP_VERSION: string

    appTitle: string
    localStorageChecked: boolean
    resourcesDownloaded: boolean
    showBrowserInfo: boolean

    theme: string
    loginTheme: string
    openedPopupCount: number

    checkLocalStorage(appVersion: string)
}

export class AppController extends IMRBaseControlDirectiveController {

    // Consts 

    private get LOG_PREFIX(): string { return '[SIMAX.App]' }

    // Consts End


    // TODO: do usunięcia
    private legendDeferred = $.Deferred<any>()
    private dateFormats = {}

    constructor(
        private readonly $rootScope: AppRootScope,
        private readonly $scope: AppScope,
        private readonly $timeout: ng.ITimeoutService,
        private readonly $interval: ng.IIntervalService,
        private readonly $window: ng.IWindowService,
        private readonly $q: ng.IQService,
        private readonly i18n,
        private readonly $state: StateService,
        private readonly $transition: TransitionService,
        private readonly api: Api,
        private readonly bowser: ng.bowser.IBowserService,
        private readonly userSession: IUserSession,
        private readonly localDictionary: LocalDictionaryFactory
    ) {
        super()

        // scope fields and methods used in index.html
        $scope.loginTheme = ConfigHelper.getDefaultValue(Enums.SimaxConfigSection.LoginScreenTheme)
        $scope.theme = ConfigHelper.getDefaultValue(Enums.SimaxConfigSection.Themes).name
        $scope.resourcesDownloaded = false
        $scope.openedPopupCount = 0

        $scope.checkLocalStorage = (appVersion) => {
            const versionsMatch: boolean = userSession
                .getDataProvider().System
                .checkAppVersion(appVersion)

            if (!versionsMatch) {
                console.warn(this.LOG_PREFIX, `Version mismatch. Refreshing page.`)

                setTimeout(() => {
                    location.reload()
                }, 300)
            }
            else {
                $scope.APP_VERSION = appVersion
                $scope.localStorageChecked = true
            }
        }
        // ---

        // global / $root fields
        $rootScope.i18n = this.i18n
        // TODO: usunąć
        $rootScope.hasPermissions = Permissions.hasPermissionsResolved
        $rootScope.dateFormatsDefer = $q.defer<void>()
        $rootScope.activeDistributorsDefer = $q.defer<any[]>()
        // ---

        // determine application state
        var hash = location.href.split("#")[1]
        if (!hash || hash.indexOf('/reset') != 0) {
            if (!api.login.isLogged() && this.$state.current.name != 'login')
                this.$state.go('login')
            else {
                this.initApp()
            }
        }
        // ---

        // determine language
        var currentLanguage = userSession.getDataProvider().System.getCurrentLanguage()
        var language = currentLanguage.split('-')[0].toUpperCase()
        // ---

        // register events
        $scope.$on(EventsNames.CHANGED_ALLOWED_DISTRIBUTORS, (e, ...args: any[]) => {
            var activeDistributorrsInfo: ActiveDistributorsInfo = args[0]
            if (activeDistributorrsInfo) {
                this.refreshActiveDistributors([activeDistributorrsInfo.singleActiveDistributor])
            }
        })
        $scope.$on(EventsNames.REFRESH_ALARMS, (e, ...args: any[]) => {
            userSession.getDataProvider().Operator.getLoggedOperator(true).then(loggedOperator => {
                if (loggedOperator) {
                    this.refreshAlarms(loggedOperator)
                }
            })
        })
        // ---

        // watch for popup length
        $scope.$watch(() => {
            return angular.element('body > .details-popup').length
        }, (val) => {
            $scope.openedPopupCount = val
        })
        // ---

        // state events
        var saveStateTimeout, stateChangeTime = performance.now()
        this.$transition.onStart({}, (transition: Transition) => {
            stateChangeTime = performance.now()

            if (['logout', 'login', 'reset', 'home'].indexOf(transition.to().name) < 0) {
                if (saveStateTimeout) $timeout.cancel(saveStateTimeout)
                saveStateTimeout = $timeout(() => {
                    userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.AppState), transition.to())
                }, 500)
            }
            else if (transition.to().name == 'login') {
                if (api.login.isLogged()) {
                    transition.abort()
                }
            }
        })

        this.$transition.onSuccess({}, (transition: Transition) => {
            CommonHelper.debug('State changes took ' + (performance.now() - stateChangeTime) + ' milliseconds')
        })

        this.$state.onInvalid(() => {
            LogHelper.warn(this.LOG_PREFIX, 'Inavlid state.')

            $state.go('home')
        })

        this.$transition.onError({}, (transition: Transition) => {
            if (transition.error().type === RejectType.ERROR) {
                LogHelper.warn(this.LOG_PREFIX, 'Unable to transition.', transition.error().toString())

                localStorage.clear()
                location.reload()
            }
        })

        // onLogged event
        $rootScope.$on(EventsNames.ON_LOGGED, () => {
            this.initApp(true)
        })
        // ---        

        // resize event
        angular.element(this.$window).on('resize', () => {
            $scope.$broadcast(EventsNames.WINDOW_RESIZED)
        })
        // ---

        // esc event
        angular.element(this.$window.document).on('keyup', (e) => {
            if (e.keyCode == 27) {
                $scope.$broadcast(EventsNames.ESC_KEY_PRESS)
            }
        })
        // ---

        // browser compatibilty info
        $timeout(() => {
            $scope.showBrowserInfo = this.checkBrowser()
        }, 2000)
        // ---

        $timeout(() => {
            $rootScope.$broadcast("showLoadingIndicator")
        }, 0)
        this.initSimaxMethods(language)
    }

    public show() {
        this.$scope.resourcesDownloaded = true
        this.$scope.appTitle = this.getAppTitle() 
        this.$rootScope.$broadcast("hideLoadingIndicator")
        if (!this.$rootScope.$$phase) this.$rootScope.$apply()
    }

    private initSimaxMethods(language: string) {
        window['simax'] = {

            //DEPRECATED Użyć ConfigHelper.getDateFormat
            getDateFormat: (format: string) => {
                var value: string = null
                if (format == 'DATE_TIME_FORMAT_DX' || format == 'DATE_TIME_FORMAT_MOMENTJS') {
                    if (this.dateFormats && this.dateFormats['PROFILE_DATE_FORMAT_LONG']) {
                        value = this.dateFormats['PROFILE_DATE_FORMAT_LONG']
                    } else if (window['config'] && window['config'].FORMATS) {
                        if (window['config'].FORMATS[language])
                            value = window['config'].FORMATS[language]['DATE_TIME_FORMAT_DX']
                        else if (window['config'].FORMATS.DEFAULT)
                            value = window['config'].FORMATS.DEFAULT['DATE_TIME_FORMAT_DX']
                    }
                }
                if (format == 'DATE_FORMAT_DX' || format == 'DATE_FORMAT_MOMENTJS') {
                    if (this.dateFormats && this.dateFormats['PROFILE_DATE_FORMAT_SHORT']) {
                        value = this.dateFormats['PROFILE_DATE_FORMAT_SHORT']
                    } else if (window['config'] && window['config'].FORMATS) {
                        if (window['config'].FORMATS[language])
                            value = window['config'].FORMATS[language]['DATE_FORMAT_DX']
                        else if (window['config'].FORMATS.DEFAULT)
                            value = window['config'].FORMATS.DEFAULT['DATE_FORMAT_DX']
                    }
                }

                if (value == null) {
                    if (format == 'DATE_TIME_FORMAT_DX' || format == 'DATE_TIME_FORMAT_MOMENTJS')
                        value = 'yyyy-MM-dd HH:mm'
                    else
                        value = 'yyyy-MM-dd'
                }

                if (format == 'DATE_TIME_FORMAT_MOMENTJS' || format == 'DATE_FORMAT_MOMENTJS')
                    value = this.getFormatForMoment(value)
                if (format != 'DATE_TIME_FORMAT_MOMENTJS' && format != 'DATE_FORMAT_MOMENTJS' && format != 'DATE_TIME_FORMAT_DX' && format != 'DATE_FORMAT_DX')
                    value = this.getFormatForMoment(format)
                return value
            },

            getMapLegend: (referenceId: number) => {
                return this.legendDeferred.promise().then(legends => {
                    if (legends) {
                        var all = legends[0]
                        if (!all) return []
                        return all.filter(item => item.referenceType === referenceId)
                    }
                })
            },

            //DEPRECATED Użyć ConfigHelper.getDateTimeFormat
            getDateTimeFormat: (format: string, idDataType: string | number = null) => {
                var necessaryFormat: string
                var value

                var formatFromDataTypeOrDefault = (format: string, idDataType: string | number) => {
                    var val: string
                    var dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(<number>idDataType)
                    if (dataType) {
                        var dtFormat = (dataType.idDataTypeClass == Enums.DataTypeClass.Real ||
                            dataType.idDataTypeClass == Enums.DataTypeClass.Integer ||
                            dataType.idDataTypeClass == Enums.DataTypeClass.Decimal) && dataType.dataTypeFormat ? dataType.dataTypeFormat.datetimeFormat : null
                        if (dtFormat) { //format from datatype
                            val = this.getFormatForMoment(dtFormat)
                            return val
                        }
                        else {
                            return this.getDefaultDatTimeFormat(format, language)
                        }
                    } else { //format from frontEnd
                        return this.getDefaultDatTimeFormat(format, language)
                    }
                }

                if (idDataType) { //format from format group                    
                    const formatGroup: OpDataFormatGroupDetails[] = this.userSession.getDataProvider().LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.DataTypeFormatGroup) || []
                    const fg: OpDataFormatGroupDetails[] = formatGroup ? formatGroup.filter(item => { return item.idDataType == idDataType }) : []

                    if (_.size(fg) > 0) {
                        const formatObj: OpDataFormatGroupDetails = fg.find((item: OpDataFormatGroupDetails) => item.dataTypeFormatOut != null)
                        necessaryFormat = formatObj.dataTypeFormatOut.datetimeFormat || TypeHelper.emptyString

                        if (format == 'DATE_FORMAT_MOMENTJS' || format == 'DATE_TIME_FORMAT_MOMENTJS') {
                            value = this.getFormatForMoment(necessaryFormat)
                        } else {
                            value = necessaryFormat
                        }
                    } else { //format from user settings
                        if (format == 'DATE_TIME_FORMAT_DX' || format == 'DATE_TIME_FORMAT_MOMENTJS') {
                            if (this.dateFormats && this.dateFormats['PROFILE_DATE_FORMAT_LONG']) {
                                value = this.dateFormats['PROFILE_DATE_FORMAT_LONG']
                                if (format == 'DATE_TIME_FORMAT_MOMENTJS')
                                    value = this.getFormatForMoment(value)
                            }
                            else {
                                value = formatFromDataTypeOrDefault(format, idDataType)
                            }
                        }

                        if (format == 'DATE_FORMAT_DX' || format == 'DATE_FORMAT_MOMENTJS') {
                            if (this.dateFormats && this.dateFormats['PROFILE_DATE_FORMAT_SHORT']) {
                                value = this.dateFormats['PROFILE_DATE_FORMAT_SHORT']
                                if (format == 'DATE_FORMAT_MOMENTJS')
                                    value = this.getFormatForMoment(value)
                            }
                            else {
                                value = formatFromDataTypeOrDefault(format, idDataType)
                            }
                        }
                    }
                } else {
                    value = window['simax'].getDateFormat(format)
                }
                return value
            },

            getDataType: (idDataType): OpDataType => {
                return this.userSession.getDataProvider().DataType.getDataTypeLocal(idDataType)
            }
        }
    }

    private checkIsThemeAvailable(theme: string) {
        const themes = ConfigHelper.getSectionValue(Enums.SimaxConfigSection.Themes)
        const selectedTheme = theme
        const foundTheme = _.find(themes, (theme: any) => theme.name === selectedTheme)
        return !!foundTheme
    }

    private refreshActiveDistributors(activeDistributors: OpDistributor[]) {
        var deffered: ng.IDeferred<ActiveDistributorsInfo> = this.$q.defer<ActiveDistributorsInfo>()
        this.userSession.getDataProvider().Distributor.getActiveDistributorsInfo(activeDistributors && activeDistributors.length > 0 ? activeDistributors[0] : null).then(activeDistributorsInfo => {
            deffered.resolve(activeDistributorsInfo)
        })
        deffered.promise.then(activeDistributorsInfo => {
            this.$rootScope.activeDistributors = activeDistributorsInfo
        })
    }

    private getActiveDistributors() {
        var resultDistributors: ActiveDistributorInfo[] = []
        this.userSession.getDataProvider().System.getAllowedList([Enums.ReferenceType.IdDistributor]).then(result => {
            var allowedDistributors: OpDistributor[]
            if (result && result.containsKey(Enums.ReferenceType.IdDistributor))
                allowedDistributors = <OpDistributor[]><any>result.tryGetValue(Enums.ReferenceType.IdDistributor).values()

            this.userSession.getDataProvider().Distributor.getIdActiveDistributors().then(idActiveDistributor => {
                allowedDistributors.forEach(distributor => {
                    var isEnabled: boolean = result && result.length > 0 && idActiveDistributor.indexOf(distributor.idDistributor) >= 0
                    resultDistributors.push(new ActiveDistributorInfo(distributor, isEnabled))
                })
                this.refreshActiveDistributors(resultDistributors.filter((element: ActiveDistributorInfo, index, array) => { return element.isActive }).map(d => { return d.distributor }))
                this.$rootScope.activeDistributorsDefer.resolve(resultDistributors)
            })
        })

    }

    private refreshAlarms(loggedOperator: OpOperator) {
        this.$timeout(() => {
            this.$scope.$root.$broadcast(EventsNames.DISABLE_LOADING_INDICATOR)
            this.userSession.getDataProvider().AlarmEvent.getAlarmEventSummary(loggedOperator.idOperator).then(result => {
                this.$scope.$root.$broadcast(EventsNames.ENABLE_LOADING_INDICATOR)
                var alarmCount: number = 0
                if (result)
                    result.forEach(r => {
                        alarmCount += r.referencecData && r.referencecData.length > 0 ? r.referencecData.length : 1
                    })
                this.$rootScope.alarmsCount = alarmCount
                this.$rootScope.alarmTiles = result
            })
        })
    }

    private initApp(afterLoggin = false) {
        this.userSession
            .getDataProvider()
            .Operator
            .getLoggedOperator(true)
            .then(loggedOperator => {
                if (loggedOperator) {
                    this.userSession
                        .setLoggedOperator(loggedOperator)
                        .then(() => {
                            ObjectCustomString.dataProvider = this.userSession.getDataProvider()

                            var settingsToLoad: Enums.SimaxOperatorSetting[] = OperatorComponent.GetBaseSettings()

                            this.userSession
                                .getDataProvider()
                                .Operator
                                .getOperatorSettings(loggedOperator.idOperator, settingsToLoad, true)
                                .then(settings => {
                                    //Logo
                                    if (settings[settingsToLoad.indexOf(Enums.SimaxOperatorSetting.Logo)] && settings[settingsToLoad.indexOf(Enums.SimaxOperatorSetting.Logo)] != undefined) {
                                        var logo: OpFile = <OpFile>settings[settingsToLoad.indexOf(Enums.SimaxOperatorSetting.Logo)]
                                        if (logo)
                                            this.$rootScope.logo = {
                                                data: logo.fileBytes,
                                                ext: Enums.FileExtension[logo.extension]
                                            }
                                    }
                                    //DateFormats
                                    this.dateFormats['PROFILE_DATE_FORMAT_LONG'] = settings[settingsToLoad.indexOf(Enums.SimaxOperatorSetting.DateFormatLong)]
                                    this.dateFormats['PROFILE_DATE_FORMAT_SHORT'] = settings[settingsToLoad.indexOf(Enums.SimaxOperatorSetting.DateFormatShort)]
                                    this.$rootScope.dateFormatsDefer.resolve()
                                    //FormatString
                                    var formatStringSettings: Enums.SimaxOperatorSetting[] = [
                                        Enums.SimaxOperatorSetting.MarkerCustomFormatStringDevice, Enums.SimaxOperatorSetting.MarkerCustomFormatStringMeter, Enums.SimaxOperatorSetting.MarkerCustomFormatStringLocation,
                                        Enums.SimaxOperatorSetting.ObjectCustomFormatStringDevice, Enums.SimaxOperatorSetting.ObjectCustomFormatStringLocation, Enums.SimaxOperatorSetting.ObjectCustomFormatStringMeter,
                                        Enums.SimaxOperatorSetting.ObjectCustomFormatStringDistributor, Enums.SimaxOperatorSetting.ObjectCustomFormatStringIssue, Enums.SimaxOperatorSetting.ObjectCustomFormatStringOperator,
                                        Enums.SimaxOperatorSetting.ObjectCustomFormatStringReport, Enums.SimaxOperatorSetting.ObjectCustomFormatStringRoute, Enums.SimaxOperatorSetting.ObjectCustomFormatStringSimCard,
                                        Enums.SimaxOperatorSetting.ObjectCustomFormatStringTask, Enums.SimaxOperatorSetting.MarkerCustomFormatStringTask
                                    ]
                                    formatStringSettings.forEach(s => {
                                        if (settings[settingsToLoad.indexOf(s)])
                                            ObjectCustomString.businessObjectCustomFormatStringDict.addOrUpdate(s, settings[settingsToLoad.indexOf(s)])
                                    })
                                    //ActiveDistributors
                                    this.getActiveDistributors()
                                })

                            if (loggedOperator.hasPermission(Activity.WEBSIMAX_ALARM_SUMMARY_VIEW)) {
                                this.refreshAlarms(loggedOperator)
                                this.$interval(() => {
                                    this.refreshAlarms(loggedOperator)
                                }, 60000 * 3)
                            }

                            // load theme
                            const defaultTheme = ConfigHelper.getDefaultValue(Enums.SimaxConfigSection.Themes).name
                            const selectedTheme = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.Theme), defaultTheme)
                            this.$scope.theme = this.checkIsThemeAvailable(selectedTheme) ? selectedTheme : defaultTheme
                            this.$scope.$on(EventsNames.THEME_CHANGE, (event: ng.IAngularEvent, ...args: any[]) => {
                                this.$scope.theme = this.checkIsThemeAvailable(args[0]) ? args[0] : defaultTheme
                            })

                            // load rtl
                            this.$rootScope.rtlState = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.RTL), window['config'].DEFAULT_RTLSTATE) == 'rtl'

                            dxConfig({
                                rtlEnabled: this.$rootScope.rtlState
                            })

                            // check previous state
                            if (afterLoggin || ['login', 'logout'].indexOf(this.$state.current.name) < 0) {
                                try {
                                    let previousState: any = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.AppState), 'home')
                                    const isStateAvailable: boolean = this.$state.get().some((state: any) => state.name === previousState.name)
                                    if (!isStateAvailable) {
                                        this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.AppState), 'home')
                                        previousState = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.AppState), 'home')
                                    }
                                    if (angular.isString(previousState)) {
                                        this.$state.go(previousState)
                                    } else if (previousState.name) {
                                        this.$state.go(previousState.name, previousState.params)
                                    }
                                } catch (e) {
                                    LogHelper.warn(this.LOG_PREFIX, `Home state is no available.`)

                                    localStorage.clear()
                                    location.reload()
                                }
                            }

                            if (loggedOperator.hasPermission(Activity.WEBSIMAX_DASHBOARD_VIEW)) {
                                // TODO: usunąć stare pobieranie dashboardu, aktualnie jest to potrzebne w innych miejscach...
                                DataProvider.Dashboard.refreshDashboards(this.api, true)
                            }

                            if (afterLoggin) {
                                // load settings after login
                                // load dictionaries
                                this.localDictionary.getDistributorHierarchyDictionary()
                            }
                        })
                }
                else {
                    LogHelper.warn(this.LOG_PREFIX, 'Unable to load operator.')

                    this.userSession.getDataProvider().System.hardReset()
                }

                //DO USUNIECIA!!! - old api
                var user = this.api.login.getUser()
                if (user.permissions) {
                    Permissions.setPermissions(user.permissions)
                }
            })
            .fail((error: any) => {
                LogHelper.warn(this.LOG_PREFIX, 'Unable to load operator.', error)

                this.userSession.getDataProvider().System.hardReset()
            })
    }

    private checkBrowser() {
        if (this.bowser.name == "Chrome" && +this.bowser.version >= 51) {
            return false
        } else if (this.bowser.name == "Safari" && +this.bowser.version >= 9) {
            return false
        } else if (this.bowser.name == "Firefox" && +this.bowser.version >= 47) {
            return false
        } else if (this.bowser.name == "Microsoft Edge" && +this.bowser.version >= 11) {
            return false
        } else if (this.bowser.name == "Internet Explorer" && +this.bowser.version >= 11) {
            return false
        } else if (this.bowser.name == "Opera" && +this.bowser.version >= 38) {
            return false
        } else {
            return true
        }
    }

    private getFormatForMoment(dateFormat: string) {
        var result: string = dateFormat
        if (result != null) {
            result = result.replace(/z/g, 'Z')
            result = result.replace(/y/g, 'Y')
            result = result.replace(/dddd/g, '****')
            result = result.replace(/ddd/g, '***')
            result = result.replace(/d/g, 'D')
            result = result.replace(/\*/g, 'd')
            result = result.replace(/f/g, 'S')
            result = result.replace(/A/g, 'a')
            result = result.replace(/tt/g, 'A')
        }
        return result
    }

    private getDefaultDatTimeFormat(format: string, language: string) {
        var val: string = null

        if (window['config'] && window['config'].FORMATS) {
            if (format == 'DATE_TIME_FORMAT_DX' || format == 'DATE_TIME_FORMAT_MOMENTJS') {
                if (window['config'].FORMATS[language])
                    val = window['config'].FORMATS[language]['DATE_TIME_FORMAT_DX']
                else if (window['config'].FORMATS.DEFAULT)
                    val = window['config'].FORMATS.DEFAULT['DATE_TIME_FORMAT_DX']
            }
            else if (format == 'DATE_FORMAT_DX' || format == 'DATE_FORMAT_MOMENTJS') {
                if (window['config'].FORMATS[language])
                    val = window['config'].FORMATS[language]['DATE_FORMAT_DX']
                else if (window['config'].FORMATS.DEFAULT)
                    val = window['config'].FORMATS.DEFAULT['DATE_FORMAT_DX']
            }
        }

        if (val == null) {
            if (format == 'DATE_TIME_FORMAT_DX' || format == 'DATE_TIME_FORMAT_MOMENTJS')
                val = 'yyyy-MM-dd HH:mm'
            else
                val = 'yyyy-MM-dd'
        }

        if (format == 'DATE_TIME_FORMAT_MOMENTJS' || format == 'DATE_FORMAT_MOMENTJS')
            val = this.getFormatForMoment(val)
        else if (format != 'DATE_TIME_FORMAT_MOMENTJS' && format != 'DATE_FORMAT_MOMENTJS' && format != 'DATE_TIME_FORMAT_DX' && format != 'DATE_FORMAT_DX')
            val = this.getFormatForMoment(val)
        return val
    }

    private getAppTitle(): string {
        return ConfigHelper.getSectionValue(Enums.SimaxConfigSection.AppTitle, { defaultValue: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AppTitle) })
    }
}